// extracted by mini-css-extract-plugin
export var deliveryRow = "_lp-a";
export var fixedHeight = "_lp-4";
export var freightLogo = "_lp-9";
export var fullWidth = "_lp-3";
export var priceColumn = "_lp-5";
export var radioSelected = "_lp-7";
export var radioUnselected = "_lp-6";
export var selectedOption = "_lp-2";
export var selectedOptionContainer = "_lp-1";
export var selection = "_lp-0";
export var tallSkeletonText = "_lp-8";